import React, { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

const CalculatorPage = lazy(() => import("./pages/CalculatorPage"));
const HistoryPage = lazy(() => import("./pages/HistoryPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/calculator" replace />} />
      <Route path="/calculator" element={<CalculatorPage />} />
      <Route path="/history" element={<HistoryPage />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
}
